import React from 'react'
import { string, func, object, bool, number } from 'prop-types'
import styled from 'styled-components'

import { highlightColor } from './colors'
import Text from './Text'

const getLinkColor = (primary, color) => {
  if (primary) {
    return highlightColor
  }

  if (color) {
    return color
  }

  return '#011627'
}

const StyledContainer = styled.span`
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

const Link = ({
  label,
  style,
  primary,
  color,
  size,
  weight,
  onClick,
  className,
}) => {
  const linkColor = getLinkColor(primary, color)
  return (
    <StyledContainer onClick={onClick} style={style}>
      <Text weight={weight} color={linkColor} size={size} className={className}>
        {label}
      </Text>
    </StyledContainer>
  )
}

Link.propTypes = {
  // label: string,
  style: object,
  onClick: func,
  primary: bool,
  weight: string,
  color: string,
  size: number,
  className: string,
}

export default Link
